// ponytail: isUseLocalStorage 只是「用 localStorage 而非 sessionStorage」的選擇，
// 不是加密——這三個函式完全沒有做任何加解密，不要把敏感憑證（密碼、token 明文）
// 存進來，也不要因為看到這個參數就誤以為資料已經受保護

/** 取得localStorage */
export function getLocalStorage<T>(key: string, isUseLocalStorage = false): T | null {
  const val = isUseLocalStorage ? localStorage.getItem(key) : sessionStorage.getItem(key)

  if (val) {
    try {
      return JSON.parse(val) as T
    } catch {
      // storage 裡存了壞掉的值（例如被手動竄改），視同沒有這筆資料，不讓全站掛掉
      return null
    }
  }

  return null
}

/** 儲存localStorage */
export function setLocalStorage<T>(key: string, val: T, isUseLocalStorage = false): void {
  isUseLocalStorage
    ? localStorage.setItem(key, JSON.stringify(val))
    : sessionStorage.setItem(key, JSON.stringify(val))
}

/** 刪除localStorage */
export function removeLocalStorage(key: string, isUseLocalStorage = false): void {
  isUseLocalStorage ? localStorage.removeItem(key) : sessionStorage.removeItem(key)
}
